export default __webpack_public_path__ + "media/images/images/banner/banner-40-1263f95e7430262dcb54b994876c2eea.jpg";